<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/23/news_02.png'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【TSK｜國際注射線上研討會】',
      //內文
      description:
        ' <b> 當填充過度影響臉部自然比例，該如何重新找回平衡？ </b> <br>面對過度填充的臨床案例，究竟該選擇降解、調整，還是先觀察？<br>而在降解填充物後，下一步又該如何評估？是重新填充、啟動再生治療，還是給予組織時間恢復？<br><br>✨TSK Expert Webinar Series｜國際注射專家線上研討會<br><br>本次特別邀請來自印尼及台灣的兩位醫師，透過實際臨床案例，分享臉部比例評估、注射調整策略，以及填充物降解後的後續治療規劃，交流不同的臨床觀點與經驗。<br><br><b>特邀講師</b><br><br><b>🇮🇩 Dr. Henry Tanojo</b><br><b>🇹🇼 Dr. Ben Liang 梁仲斌醫師</b><br><br>📅 研討會資訊<br>日期｜2026 年 10 月 27 日（二）<br>時間｜台灣 20:00–21:30<br>形式｜ZOOM 線上講座｜免費報名<br><br><b>🔗 立即報名：</b><br><a href="http://tiny.cc/tskwebinaroct2026" target="_blank" rel="noopener noreferrer"><b>http://tiny.cc/tskwebinaroct2026</b></a><br><br>誠摯邀請各位醫師一同參與，從臨床案例中交流注射美學與治療策略，探索如何在精準調整與自然平衡之間，做出更合適的臨床判斷！',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
